function positionGridCards() {
    const gridContainer = document.querySelector('.product-list [class*="grid"]');
    if (!gridContainer) return;

    const gridCards = Array.from(gridContainer.querySelectorAll('[data-grid-card]'));

    // Sort grid cards by position (lowest first)
    gridCards.sort((a, b) => {
        const posA = parseInt(a.dataset.gridPosition) || 0;
        const posB = parseInt(b.dataset.gridPosition) || 0;
        return posA - posB;
    });

    gridCards.forEach(card => {
        const targetPosition = parseInt(card.dataset.gridPosition) || 0;

        if (targetPosition === 0) return; // Stay at end

        const targetProduct = gridContainer.querySelector(`[data-position="${targetPosition}"]`);

        if (targetProduct) {
            // Insert grid card before the target product
            gridContainer.insertBefore(card, targetProduct);
        }
    });
}

// Run on page load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionGridCards);
} else {
    positionGridCards();
}

// Re-run after Shopify section reload
document.addEventListener('shopify:section:load', positionGridCards);

// Re-run after filter AJAX updates via ThemeBus
// 'grid:updated' is dispatched by filters.js; 'filters:updated' is dispatched by both
// filter scripts (including faceted-navigation-filters.js which skips grid:updated)
function setupThemeBusListeners() {
  if (window.ThemeBus) {
    window.ThemeBus.addEventListener('grid:updated', positionGridCards);
    window.ThemeBus.addEventListener('filters:updated', positionGridCards);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupThemeBusListeners);
} else {
  setupThemeBusListeners();
}